module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starEmpty-959c955d842745ff1876ab5e2556e5a2.png";